// 单文件引入方式

import Button from './ZuiButton.vue'

export default {
  install(Vue) {
    Vue.component('ZuiButton', Button)
  }
}

export { Button }
